<template lang="pug">
.form-product.center(:class="{'inside-padding': !fillData}")
  .section-title(@click="showSection('quantities')" name="SectionTitle" v-if="fillData") Cantidades
  div(v-if="sections.quantities.show && fillData")
    .table-quantities
      .headers-quantities
        span.size Talla
        span.available Disponibles
        span.pending Pendientes
        span.total Bodega
      .body-quantities
        .row-body(v-for="(size, index) in dataForm.sizes" :style="`order:${order[size]}`")
          span.size.size-cell
            shActionButton(
              v-if="dataForm.sizes.length > 1"
              :action="deleteProductSize"
              :params="[size]"
              icon="close"
              text="Eliminar talla"
              textRunning="Eliminando"
              :warning="true"
              :textConfirmation="deleteSizeConfirmation(size)"
            )
            span.uppercase {{ size }}
          span.available {{ quantityAvailable(index) }}
          span.pending(@click="pendingOrders(index) ? showPending(index) : null" :class="{'underline pointer': pendingOrders(index)}") {{ pendingOrders(index) }}
          span.total.pointer.underline(@click="showWarehouse(size)") {{ warehouseQuantity(index) }}

  shTiers(:show="warehouse.show" :product="dataForm" :size="warehouse.size" @close="warehouse.show = false" @updateTiers="handleUpdateTiers")
  shPendingOrders(:show="pending.show" :product="dataForm" :size="pending.size" @close="pending.show = false")

  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}

    .section-title(@click="showSection('general')" name="SectionTitle") Datos Generales

    .section-container(v-if="sections.general.show")
      .form-section
        .input-container
          input.input(v-model="dataForm.product" autocomplete="ño" :disabled="true" required)
          label.label(:class="{ show: dataForm.product }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="product" title="Product Name")

        div {{ msgProductRelated }}

      .form-section
        .input-container.arrow
          select.select(v-model="dataForm.brand" :disabled="fillData" @change="getDataDefault"  autocomplete="ño" required)
            option(value="")
            option(v-for="brand in brands" :value="brand") {{ capitalize(brand) }}
          label.label(:class="{ show: dataForm.brand }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="brand" title="Marca")
        .input-container
          select.select(v-model="dataForm.person" :disabled="fillData" @change="getDataDefault"  autocomplete="ño" required)
            option(v-for="person in persons" :value="person.person") ({{ capitalize(person.letter) }}) {{ capitalize(person.person) }}
          label.label(:class="{ show: dataForm.person }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="person" title="Persona")
        .input-container
          select.select(v-model="dataForm.article" :disabled="fillData" @change="getDataDefault"  autocomplete="ño" required)
            option(v-for="article in articles" :value="article.article") ({{ capitalize(article.letter) }}) {{ capitalize(article.article) }}
          label.label(:class="{ show: dataForm.article }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="article" title="Artículo")
        .input-container
          select.select(v-model="dataForm.design" @change="getDataDefault"  autocomplete="ño" required)
            option(v-for="design in designs" :value="design") {{ capitalize(design) }}
          label.label(:class="{ show: dataForm.design }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="design" title="Diseño")

        div {{ msgArticleDefault }}

      // .form-section
        .input-container
          input.input(v-model.number="dataForm.order"  type="number" autocomplete="ño" required)
          label.label(:class="{ show: Number.isInteger(dataForm.order) }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="order" title="Orden")

        .input-container
          input.input(v-model.number="dataForm.suborder"  type="number" autocomplete="ño" required)
          label.label(:class="{ show: dataForm.suborder >= 0 }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="suborder" title="Suborder")

        .input-container
          input.input(v-model.number="dataForm.group"  type="number" autocomplete="ño")
          label.label(:class="{ show: dataForm.group >= 0 }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="group" title="Grupo")

      .left
        .sub-title Colores

      .form-section
        shSelectList(:dataForm="dataForm" :dataOriginal="dataOriginal" title="Color" property="colors" :fillData="fillData" :options="colors" :caps="true" :required="1" :line="true")

      shVariantsEditor(:dataForm="dataForm" :dataOriginal="dataOriginal" :fillData="fillData")

      .left
        .sub-title Palabras Claves

      .form-section
        shInputList(:dataForm="dataForm" :dataOriginal="dataOriginal" title="" property="keywords" :line="true")

    .section-title(@click="showSection('prices')" name="SectionTitle") Precios y Costos
    .section-container(v-if="sections.prices.show")
      .form-section
        .input-container
          input.input(v-model.number="dataForm.priceUnit"  type="number" min="0" max="1000000" autocomplete="ño" required)
          label.label(:class="{ show: dataForm.priceUnit > 0 }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="priceUnit" title="Unidad")

        .input-container
          input.input(v-model.number="dataForm.priceWholesaler"  type="number" min="0" max="1000000" autocomplete="ño" required)
          label.label(:class="{ show: dataForm.priceWholesaler > 0 }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="priceWholesaler" title="Mayorista")

        .input-container
          input.input(v-model.number="dataForm.priceSale"  type="number" min="0" max="1000000" autocomplete="ño" required)
          label.label(:class="{ show: dataForm.priceSale > 0 }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="priceSale" title="Promoción")

      shActionButton.button-load(:action="getArticleDefaultPrices" text="Cargar Precios" textRunning="Cargando..." :mini="true")

      .form-section
        .input-container
          input.input(v-model.number="dataForm.cost"  type="number" min="0" max="1000000" autocomplete="ño")
          label.label(:class="{ show: dataForm.cost > 0 }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="cost" title="Costo")

    // .form-section
      .input-container
        input.input(v-model="dataForm.folder" autocomplete="ño" :disabled="true" required)
        label.label(:class="{ show: dataForm.folder }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="folder" title="Archivo")

      .input-container
        input.input(v-model="dataForm.subfolder" autocomplete="ño" :disabled="true" required)
        label.label(:class="{ show: dataForm.subfolder }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="subfolder" title="Sub Archivo")

    .section-title(@click="showSection('images')" name="SectionTitle") Imágenes
    .section-container(v-if="sections.images.show")

      .form-section
        shUploadImage(v-if="dataForm.brand && dataForm.person" :brand="dataForm.brand" :person="dataForm.person" @uploaded="addImage" title="")

      .form-section
        TransitionGroup.images-product-container(name="slide-fade")
          .image(v-for="(image, index) in dataForm.images" :key="image")
            div {{ image }}
            img(:src="`${imagePath}/${dataForm.brand}/${dataForm.folder}/${dataForm.subfolder}/${image}`")
            .buttons-image
              shActionButton(v-if="index" :action="toLeft" :params="[index]" text="<" textRunning="<" :mini="true")
              shActionButton(v-if="dataForm.images.length - 1 !== index" :action="toRight" :params="[index]" text=">" textRunning=">" :mini="true")
              shActionButton(:action="deleteImage" :params="[index]" text="x" textRunning="x" :mini="true" :warning="true")

      // Buscar Imágenes
      .form-section
        shSearch(title="Buscar Imagen" @selectImage="(image) => { addImage(image.image) }")

      .checkbox-section
        .input-container-checkbox
          label.label-checkbox(:for="`old${dataForm.product}`")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="old" title="Images Antiguas")
            input.input-checkbox(v-model="dataForm.old" :id="`old${dataForm.product}`" type="checkbox")
            .checkmark

    .section-title(@click="showSection('imagesMeasure')" name="SectionTitle") Medidas
    .section-container(v-if="sections.imagesMeasure.show")
      .form-section
        shUploadImage(@uploaded="(image) => addImage(image, true)" url="img/measures" title="")

      .form-section
        TransitionGroup.images-measure-container(name="slide-fade")
          .image(v-for="(image, index) in dataForm.imagesMeasure" :key="image")
            div {{ image }}
            shDimensionsLines(:src="`https://sahet-cdn.b-cdn.net/img/measures/${image}`" @updateText="(texts) => { saveText(index, texts) }" :texts="dataForm.texts[index]")
            .buttons-image
              shActionButton(v-if="index" :action="toLeft" :params="[index, true]" text="<" textRunning="<" :mini="true")
              shActionButton(v-if="dataForm.imagesMeasure.length - 1 !== index" :action="toRight" :params="[index, true]" text=">" textRunning=">" :mini="true")
              shActionButton(:action="deleteImage" :params="[index, true]" text="x" textRunning="x" :mini="true" :warning="true")

      .form-section
        shSearch(title="Buscar Imagen Medidas" @selectImage="(image) => { addImage(image.image, true) }")

      shActionButton.button-load(:action="getArticleDefaultImages" text="Cargar de Imágenes Predeterminadas" textRunning="Actualizando..." :mini="true")

      .input-container
        textarea.input(v-model="dataForm.measurementsText" autocomplete="ño" rows="8")
        label.label(:class="{ show: dataForm.measurementsText }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="measurementsText" title="Texto de Medidas" :caseSensitive="true")

    .section-title(@click="showSection('details')" name="SectionTitle") Detalles
    .section-container(v-if="sections.details.show")
      .form-section
        .input-container
          input.input(v-model="dataForm.title" autocomplete="ño" rows="8" required)
          label.label(:class="{ show: dataForm.title }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="title" title="Título")

        .input-container
          textarea.input(v-model="dataForm.conditions" autocomplete="ño" rows="8" required)
          label.label(:class="{ show: dataForm.conditions }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="conditions" title="Cuidados" :caseSensitive="true")

        .input-container
          textarea.input(v-model="dataForm.material" autocomplete="ño" rows="8" required)
          label.label(:class="{ show: dataForm.material }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="material" title="Material" :caseSensitive="true")

        .input-container
          textarea.input(v-model="dataForm.description" autocomplete="ño" rows="8" required)
          label.label(:class="{ show: dataForm.description }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="description" title="Descripción" :caseSensitive="true")

    //.divider

    //.checkbox-section
      .input-container-checkbox
        label.label-checkbox(:for="`isWinner${dataForm.product}`")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="isWinner" title="Producto Ganador")
          input.input-checkbox(v-model="dataForm.isWinner" :id="`isWinner${dataForm.product}`" type="checkbox")
          .checkmark

    //.input-container
      input.input(v-model.number="dataForm.orderWinner"  type="number" autocomplete="ño")
      label.label(:class="{ show: Number.isInteger(dataForm.orderWinner) }")
        shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="orderWinner" title="Orden Ganador")

    .section-title(@click="showSection('state')" name="SectionTitle") Estado
    .section-container(v-if="sections.state.show")
      .checkbox-section
        .input-container-checkbox
          label.label-checkbox(:for="`lastUnits${dataForm.product}`")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="lastUnits" title="Últimas Unidades")
            input.input-checkbox(v-model="dataForm.lastUnits" :id="`lastUnits${dataForm.product}`" type="checkbox")
            .checkmark
      .checkbox-section
        .input-container-checkbox
          label.label-checkbox(:for="`clearence${dataForm.product}`")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="isClearence" title="En Liquidación")
            input.input-checkbox(v-model="dataForm.isClearence" :id="`clearence${dataForm.product}`" type="checkbox")
            .checkmark

      .checkbox-section
        .input-container-checkbox
          label.label-checkbox(:for="`active${dataForm.product}`")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="active" title="Activo")
            input.input-checkbox(v-model="dataForm.active" :id="`active${dataForm.product}`" type="checkbox")
            .checkmark

      .checkbox-section
        .input-container-checkbox
          label.label-checkbox(:for="`update${dataForm.product}`")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="update" title="Actualizar Con Artículos Predeterminados")
            input.input-checkbox(v-model="dataForm.update" :id="`update${dataForm.product}`" type="checkbox")
            .checkmark

    .form-actions(v-if="fillData")
      shActionButton.button-submit(:isForm="true" text="Actualizar" textRunning="Actualizando" :action="sendForm")
      shActionButton.button-replicate(:action="openReplicateModal" text="Replicar" textRunning="Replicar" :normalColor="true")
    shActionButton.button-submit(v-else :isForm="true" text="Guardar" textRunning="Guardando" :action="sendForm")

  shReplicateProductModal(
    v-if="fillData"
    :show="replicateModal.show"
    :sourceProduct="dataForm"
    @close="replicateModal.show = false"
    @replicated="replicateModal.show = false"
  )

  .right(v-if="fillData")
    shDeleteButton(@delete="deleteProduct")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import mDB from '@/mixins/db'
import gql from '@my/graphql'
import gqlProduct from '@/graphql/product'
import gqlArticleDefault from '@/graphql/articleDefault'
import shSelectList from '@/components/elements/SelectList'
import shInputList from '@/components/elements/InputList'
import shInputImageList from '@/components/elements/InputImageList'
import shUploadImage from '@/components/pages/image/FormUpload'
import shDimensionsLines from '@/components/elements/DimensionLines.vue'
import modals from '@my/store/modals'
import shSearch from './Search.vue'
import shTiers from './Tiers.vue'
import shPendingOrders from './Pending.vue'
import shVariantsEditor from './VariantsEditor.vue'
import shReplicateProductModal from './ReplicateProductModal.vue'

export default {
  name: 'FormProduct',

  mixins: [mForm, mFilters, mDB],

  components: { shSelectList, shInputImageList, shUploadImage, shDimensionsLines, shInputList, shSearch, shTiers, shPendingOrders, shVariantsEditor, shReplicateProductModal },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        product: '',
        article: '',
        person: '',
        design: '',
        colors: [''],
        images: [],
        sizes: [''],
        priceUnit: 0,
        priceWholesaler: 0,
        priceSale: 0,
        cost: 0,
        folder: '',
        subfolder: '',
        measurementsImage: '',
        title: '',
        conditions: '',
        material: '',
        description: '',
        ecologicalDescription: '',
        active: false,
        brand: '',
        imagesMeasure: [],
        texts: [],
        update: false,
        keywords: [''],
        pinned: [''],
        old: false,
        showLast: [],
        isWinner: false,
        lastUnits: false,
        variants: []
      },
      productsRelated: [],
      msgArticleDefault: '',
      msgProductRelated: '',
      resolver: 'product',
      key: 'product',
      gql: gqlProduct,
      gqlArticleDefault: gqlArticleDefault,
      delete: ['sizes', 'tiers', 'quantityAvailable', 'pendingOrders', 'inStock', 'errorStock', 'totalAvailable', 'createdAt', 'updatedAt', 'variants.colorName'],
      order: { 'xxs': 1, 'xs': 2, 's': 3, 'm': 4, 'l': 5, 'xl': 6, 'xxl': 7, '0': 8, '1': 9, '2': 10, '3': 11, '4': 12, '5': 13, '6': 14, '7': 15, '8': 16, '9': 17, '10': 18, '11': 19, '12': 20, '13': 21, '14': 22, '15': 23, '16': 24, '17': 25, '18': 26, '19': 27, '20': 28, '21': 29, '22': 30, '23': 31, '24': 32, '25': 33, '26': 34, '27': 35, '28': 36, '29': 37, '30': 38, '31': 39, '32': 40, '33': 41, '34': 42, '35': 43, '36': 44, '37': 45, '38': 46, '39': 47, '40': 48, '41': 49, '42': 50 },
      material: { notRemove: true },
      conditions: { notRemove: true },
      description: { notRemove: true },
      measurementsText: { notRemove: true },

      warehouse: {
        show: false,
        size: ''
      },
      pending: {
        show: false,
        size: ''
      },

      sections: {
        general: {
          show: false
        },
        quantities: {
          show: false
        },
        colors: {
          show: false
        },
        prices: {
          show: false
        },
        description: {
          show: false
        },
        images: {
          show: false
        },
        imagesMeasure: {
          show: false
        },
        details: {
          show: false
        },
        state: {
          show: false
        }
      },

      replicateModal: {
        show: false
      }
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
    if (this.dataForm.keywords.length === 0) this.dataForm.keywords.push('')
    if (this.dataForm.pinned.length === 0) this.dataForm.pinned.push('')
  },

  mounted () {
    if (!this.fillData) {
      this.showSection('general')
      this.showSection('prices')
      this.showSection('images')
      this.showSection('imagesMeasure')
      this.showSection('details')
      this.showSection('state')
    }
  },

  methods: {
    showSection (section) {
      this.sections[section].show = !this.sections[section].show
    },

    openReplicateModal () {
      this.replicateModal.show = true
      return true
    },

    sendForm () {
      if (!this.fillData) {
        this.newProduct()
      } else {
        this.updateProduct()
      }
    },

    newProduct () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateProduct () {
      if (!this.dataForm.isWinner && this.dataOriginal.orderWinner !== this.dataForm.orderWinner) {
        modals.showMessage({ message: 'No se puede actualizar el orden ganador a menos que sea un producto ganador', type: 'error' })
        return
      }
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteProduct () {
      this.deleteData(this.gql, this.resolver, this.key)
    },

    async getDataDefault () {
      if (this.fillData) return

      const { person, article, design, brand } = this.dataForm

      if (person && article && design) {
        await this.getProductsRelated({ person, article, brand })
        await this.getArticleDefault({ person, article, design })
        this.createProductName()
      }
    },

    async getProductsRelated (options) {
      const query = gqlProduct.GET_DATA_RELATED

      const response = await gql.query(query, options, false)

      if (!response) {
        this.msgProductRelated = 'We can\'t connect to data base'
      } else {
        if (response.data && !response.data.getProductsRelated) {
          this.msgProductRelated = 'There are no products related'
        } else {
          this.productsRelated = response.data.getProductsRelated
        }
      }
    },

    createProductName () {
      const nextProduct = this.productsRelated.length + 1

      const articleChoosen = this.articles.find(({ article }) => article === this.dataForm.article)
      const genderChoosen = this.persons.find(({ person }) => person === this.dataForm.person)

      const letterArticle = this.capitalize(articleChoosen.letter)
      const letterGender = this.capitalize(genderChoosen.letter)

      this.dataForm.product = `${letterGender}${letterArticle}${nextProduct}`
    },

    async getArticleDefault (options) {
      const query = gqlArticleDefault.GET_ONE

      const response = await gql.query(query, options, false)

      if (!response) {
        modals.showMessage({ message: 'No ha sido posible conectarse a la base de datos', type: 'error' })
      } else {
        if (response.data && !response.data.getArticleDefault) {
          this.initDefaults()
          modals.showMessage({ message: 'Este tipo de artículo no tiene datos predeterminados', type: 'error' })
        } else {
          this.overrideDefauts(response.data.getArticleDefault, { updateImages: true, updatePrices: true, updateOthers: true })
          modals.showMessage({ message: 'Datos predeterminados cargados con exito' })
        }
      }
    },

    async getArticleDefaultPrices () {
      const query = gqlArticleDefault.GET_ONE
      const { person, article, design, brand } = this.dataForm
      const options = { person, article, design, brand }

      const response = await gql.query(query, options, false)

      if (!response) {
        modals.showMessage({ message: 'No ha sido posible conectarse a la base de datos', type: 'error' })
      } else {
        if (response.data && !response.data.getArticleDefault) {
          modals.showMessage({ message: 'Este tipo de artículo no tiene datos predeterminados', type: 'error' })
        } else {
          this.overrideDefauts(response.data.getArticleDefault, { updatePrices: true })
          modals.showMessage({ message: 'Precios y costos predeterminados cargados con exito' })
        }
      }
    },

    async getArticleDefaultImages () {
      const query = gqlArticleDefault.GET_ONE
      const { person, article, design, brand } = this.dataForm
      const options = { person, article, design, brand }

      const response = await gql.query(query, options, false)

      if (!response) {
        modals.showMessage({ message: 'No ha sido posible conectarse a la base de datos', type: 'error' })
      } else {
        if (response.data && !response.data.getArticleDefault) {
          modals.showMessage({ message: 'Este tipo de artículo no tiene datos predeterminados', type: 'error' })
        } else {
          this.overrideDefauts(response.data.getArticleDefault, { updateImages: true })
          modals.showMessage({ message: 'Imagenes predeterminados cargados con exito' })
        }
      }
    },

    initDefaults () {
      this.dataForm.priceUnit = ''
      this.dataForm.priceWholesaler = ''
      this.dataForm.priceSale = ''
      this.dataForm.cost = ''
      this.dataForm.order = ''
      this.dataForm.suborder = ''
      this.dataForm.imagesMeasure = []
      this.dataForm.texts = []
      this.dataForm.keywords = ['']
    },

    overrideDefauts (data, { updatePrices, updateImages, updateOthers }) {
      const { priceUnit, priceWholesaler, priceSale, cost, order, imagesMeasure, texts, keywords } = data
      if (updatePrices) this.dataForm.priceUnit = priceUnit
      if (updatePrices) this.dataForm.priceWholesaler = priceWholesaler
      if (updatePrices) this.dataForm.priceSale = priceSale
      if (updatePrices) this.dataForm.cost = cost
      if (updateOthers) this.dataForm.order = order
      if (updateOthers) this.dataForm.keywords = keywords && keywords.length ? [...keywords] : ['']
      if (updateImages) this.dataForm.imagesMeasure = imagesMeasure
      if (updateImages) this.dataForm.texts = texts
    },

    addImage (name, isMeasure) {
      const array = isMeasure ? this.dataForm.imagesMeasure : this.dataForm.images
      const index = array.findIndex(imageName => imageName === name)
      if (index >= 0) array.splice(index, 1)

      if (isMeasure && index >= 0) {
        this.dataForm.texts.splice(index, 1)
        this.dataForm.texts.push('')
      }

      array.push(name)
    },

    toLeft (index, isMeasure) {
      if (!index) return

      const array = isMeasure ? this.dataForm.imagesMeasure : this.dataForm.images
      const image = array[index]
      array.splice(index, 1)
      array.splice(index - 1, 0, image)

      if (isMeasure) {
        const text = this.dataForm.texts[index]
        this.dataForm.texts.splice(index, 1)
        this.dataForm.texts.splice(index - 1, 0, text)
      }
    },

    toRight (index, isMeasure) {
      const array = isMeasure ? this.dataForm.imagesMeasure : this.dataForm.images
      if ((array.length - 1) === index) return

      const image = array[index]
      array.splice(index, 1)
      array.splice(index + 1, 0, image)

      if (isMeasure) {
        const text = this.dataForm.texts[index]
        this.dataForm.texts.splice(index, 1)
        this.dataForm.texts.splice(index + 1, 0, text)
      }
    },

    isMeasurementsImage (index) {
      const image = this.dataForm.images[index]
      const measurementsImage = this.dataForm.measurementsImage
      if (measurementsImage) this.dataForm.images.push(measurementsImage)

      this.dataForm.images.splice(index, 1)
      this.dataForm.measurementsImage = image
    },

    deleteImage (index, isMeasure) {
      const array = isMeasure ? this.dataForm.imagesMeasure : this.dataForm.images
      array.splice(index, 1)

      if (isMeasure) {
        this.dataForm.texts.splice(index, 1)
      }
    },

    deleteImageMeasurements () {
      this.dataForm.measurementsImage = ''
    },

    isProduct () {
      const image = this.dataForm.measurementsImage
      this.dataForm.measurementsImage = ''
      this.dataForm.images.push(image)
    },

    saveText (index, texts) {
      this.dataForm.texts[index] = JSON.stringify(texts)
    },

    handleUpdateTiers ({ action, indexSize, indexTier, tier }) {
      const quantityAvailable = this.dataForm.quantityAvailable[indexSize]
      if (action === 'delete') {
        this.$set(this.dataForm.quantityAvailable, indexSize, quantityAvailable - 1)
      } else if (action === 'add') {
        this.$set(this.dataForm.quantityAvailable, indexSize, quantityAvailable + 1)
      }
    },

    showPending (indexSize) {
      this.pending.show = true
      this.pending.size = this.dataForm.sizes[indexSize]
    },

    showWarehouse (size) {
      this.warehouse.show = true
      this.warehouse.size = size
    },

    deleteSizeConfirmation (size) {
      return `Se eliminará la talla ${size.toUpperCase()} del producto ${this.dataForm.product}`
    },

    async deleteProductSize (size) {
      const response = await gql.mutate(gqlProduct.DELETE_PRODUCT_SIZE, {
        product: this.dataForm.product,
        size
      })

      if (!response || !response.data || !response.data.deleteProductSize) return

      const updated = response.data.deleteProductSize
      const fields = ['sizes', 'quantityAvailable', 'tiers', 'pendingOrders', 'showLast', 'inStock', 'totalAvailable']

      for (const field of fields) {
        if (updated[field] !== undefined) {
          this.$set(this.dataForm, field, updated[field])
          if (this.dataOriginal) this.$set(this.dataOriginal, field, updated[field])
        }
      }

      modals.showMessage({ message: `Se eliminó la talla ${size.toUpperCase()} del producto ${this.dataForm.product}` })
    },

    quantityAvailable (indexSize) {
      if (indexSize === -1) return 0
      return this.dataForm.quantityAvailable[indexSize]
    },

    pendingOrders (indexSize) {
      if (indexSize === -1) return 0
      if (!this.dataForm.pendingOrders[indexSize]) return 0
      return this.dataForm.pendingOrders[indexSize].length
    },

    warehouseQuantity (indexSize) {
      if (indexSize === -1) return 0
      if (!this.dataForm.tiers[indexSize]) return 0
      return this.dataForm.tiers[indexSize].length
    }
  },

  computed: {
    persons () {
      return this.$store.state.persons
    },
    articles () {
      return this.$store.state.variables.articles
    },
    designs () {
      return this.$store.state.variables.designs
    },
    sizes () {
      return this.$store.state.variables.sizes
    },
    colors () {
      return this.$store.state.variables.colors
    },
    brands () {
      return this.$store.state.variables.brands
    }
  },

  watch: {
    dataOriginal: {
      handler () {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    },
    'dataForm.person': function (newVal) {
      this.dataForm.subfolder = newVal
      this.dataForm.folder = 'products'
    }
  }
}
</script>

<style lang="stylus" scoped>
.form-product
  position relative

.preview-text
  margin 1em 0

.title-stock
  font-weight 600
  font-size 1.1em
  margin 1em 0 .2em 0

.container-data-available
  padding 0 3em

.container-data-available > div
  display flex
  flex-direction column

.images-product-container, .images-measure-container
  display flex
  flex-wrap wrap
  gap 1em
  flex-direction row
  justify-content center
  margin-bottom 2em

.images-product-container > .image
  max-width 30em
  width 30%
  flex-shrink 0
  flex-basis 30em

.images-measure-container > .image
  max-width 40em
  width 30%
  flex-shrink 0
  flex-basis 40em

.images-product-container > .image > img
  width 30em

.buttons-image
  display flex
  gap 1em
  justify-content center

.button-load
  opacity .4

.button-load:hover
  opacity 1

.button-submit
  margin-top 2rem

.form-actions
  display flex
  gap 1rem
  margin-top 2rem
  flex-wrap wrap

.form-actions .button-submit
  margin-top 0

.button-replicate
  flex-shrink 0

.section-title
  display inline-flex
  justify-content space-between
  align-items center
  gap 1em
  text-align center
  width 100%
  cursor pointer
  font-size 1.2rem
  font-weight 600
  margin-top 2rem

.table-quantities
  width 100%
  overflow-x auto

.headers-quantities
  display flex
  align-items center
  text-align center
  width 100%
  cursor pointer
  font-size 1.2rem
  font-weight 600
  margin-top 2rem
  text-align left
  margin-bottom .5rem

.body-quantities
  display flex
  flex-direction column
  align-items center
  text-align center
  width 100%
  font-size 1.2rem
  text-align left

.row-body
  display flex
  align-items center
  text-align center
  width 100%
  height 2.75rem
  font-size 1.2rem
  text-align left

.row-body > span
  border-top 1px solid rgba(0, 0, 0, 0.3)
  padding 0 .5em
  height 100%
  display flex
  align-items center

.row-body .size,
.headers-quantities .size
  width 8rem
  flex-shrink 0

.size-cell
  display flex
  align-items center
  gap .35rem

.row-body .available,
.headers-quantities .available
  width 10rem
  flex-shrink 0

.row-body .pending,
.headers-quantities .pending
  width 10rem
  flex-shrink 0

.row-body .total,
.headers-quantities .total
  width 6rem
  flex-shrink 0
</style>



// WEBPACK FOOTER //
// src/components/pages/product/Form.vue